










import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VProjectHeaderTitle extends Vue {
  @Prop({ required: true }) project!: string;
}
